import { AmplifyAuthService } from './HPAuth';

export const HPAuth = AmplifyAuthService();

export * from './types';
export * from './firebase';
